var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-overlay',{attrs:{"show":_vm.loading}},[_c('table-data-widget',{attrs:{"columns":_vm.cColumns,"items":_vm.items,"view-able":""},on:{"clickView":_vm.tableClickView}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }